module.exports = __webpack_public_path__ + "img/CW.a266452b.svg";